import axios from 'axios'

const DEFAULT_TIMEZONE = 'Asia/Calcutta'

const getTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIMEZONE
  } catch {
    return DEFAULT_TIMEZONE
  }
}

axios.defaults.headers.common['platform'] = 'Web'
axios.defaults.headers.common['Timezone'] = getTimezone()

export default axios
